import { Stack } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import { Link } from 'react-router';

import KeyValueResponsive from '@/components/KeyValueResponsive';
import type { KeyValueResponsiveModel } from '@/components/KeyValueResponsive/KeyValueResponsive.types';
import { LargeCard } from '@/components/LargeCard';
import MultiPartScoreBadge from '@/components/MultiPartScoreBadge/MultiPartScoreBadge';
import VMPGenericChip from '@/components/VMPGenericChip/VMPGenericChip';
import { assetRiskScoreDialogAtom } from '@/pages/Assets/Assets.store';
import { scorePartsNoTotal } from '@/pages/Assets/Assets.utils';
import { caseDetailsAtom } from '@/pages/Case/Case.store';
import type {
  AssetDTO,
  CriticalityTypes
} from '@/pages/VulnerabilityManagement/VulnerabilityManagement.types';

import useStyles from './CaseAssetDetails.styles';

const CaseAssetDetails = () => {
  const { classes } = useStyles();
  const caseDetails = useAtomValue(caseDetailsAtom);
  const [, setAssetRiskScoreDialog] = useAtom(assetRiskScoreDialogAtom);

  const kvItems: KeyValueResponsiveModel[] = [
    {
      label: 'Criticality',
      value: caseDetails?.asset?.criticality ? (
        <VMPGenericChip
          type="filled"
          value={caseDetails?.asset?.criticality as CriticalityTypes}
        />
      ) : (
        '--'
      )
    },
    {
      label: 'Asset Subtype',
      value: caseDetails?.asset?.asset_subtype || '--'
    },
    {
      label: 'Operating System',
      value: caseDetails?.asset?.operating_system || '--'
    },
    {
      label: 'IP Address',
      value: caseDetails?.asset?.ip_address || '--'
    },
    {
      label: 'Turbine Assigned Affected Host',
      value:
        caseDetails?.soc_case_extra_details?.enrichment?.affected_hostname ||
        '--'
    }
  ];

  return (
    <LargeCard title="Asset Details" className={classes.caseAssetDetails}>
      <Stack>
        <Stack
          sx={{ alignItems: 'center' }}
          direction="row"
          className={classes.assetNameContainer}
        >
          {caseDetails?.asset?.risk_score !== undefined && (
            <MultiPartScoreBadge
              score={caseDetails?.asset?.risk_score || 0}
              parts={scorePartsNoTotal(
                caseDetails?.asset?.risk_score_details || {}
              )}
              height={30}
              width={30}
              handleClick={() =>
                setAssetRiskScoreDialog(caseDetails?.asset as AssetDTO)
              }
            />
          )}
          {caseDetails?.asset && (
            <Link
              to={`/asset/${caseDetails?.asset?.id}`}
              style={{
                fontSize: '1.25rem',
                textDecoration: 'none'
              }}
            >
              {caseDetails?.asset?.asset_name}
            </Link>
          )}
        </Stack>
        <KeyValueResponsive items={kvItems} />
      </Stack>
    </LargeCard>
  );
};

export default CaseAssetDetails;
